import { useEffect, useState } from "react";

const UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "minutes", label: "Minutes" },
  { key: "seconds", label: "Seconds" },
];

function calc(target) {
  const diff = Math.max(0, target - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

export default function Countdown({ targetIso }) {
  const target = new Date(targetIso).getTime();
  const [t, setT] = useState(() => calc(target));

  useEffect(() => {
    const id = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  return (
    <div data-testid="countdown" className="flex items-start justify-center gap-6 md:gap-12">
      {UNITS.map((u) => (
        <div key={u.key} className="text-center">
          <div className="font-serif text-5xl leading-none text-primary md:text-7xl">
            {String(t[u.key]).padStart(2, "0")}
          </div>
          <div className="overline mt-3 text-foreground/60">{u.label}</div>
        </div>
      ))}
    </div>
  );
}
